import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["className", "children", "position"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import cn from 'classnames';
import { MenuItem } from './menu-item';
import { menuClasses } from './menu';
import { PopupPositionType, PopupTriggerType, popupClasses } from '../../popup';
import { Popover } from '../../popover/index';
export var MenuDropdown = function (_React$PureComponent) {
  _inherits(MenuDropdown, _React$PureComponent);
  var _super = _createSuper(MenuDropdown);
  function MenuDropdown() {
    _classCallCheck(this, MenuDropdown);
    return _super.apply(this, arguments);
  }
  _createClass(MenuDropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        position = _this$props.position,
        menuItemProps = _objectWithoutProperties(_this$props, _excluded);
      var classNames = cn(menuClasses.HAS_DROPDOWN, _defineProperty({}, popupClasses.DISMISS, this.props.shouldDismissPopover), className);
      return React.createElement(Popover, {
        position: this.props.position,
        content: children,
        usePortal: true,
        isMinimal: true,
        trigger: this.props.trigger
      }, React.createElement(MenuItem, _extends({
        className: classNames
      }, menuItemProps)));
    }
  }]);
  return MenuDropdown;
}(React.PureComponent);
_defineProperty(MenuDropdown, "defaultProps", {
  position: PopupPositionType.BOTTOM,
  trigger: PopupTriggerType.HOVER
});